<template>
  <div class="home-page">
    <PcHome />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PicNewspaper from "./components/PicNewspaper.vue";
import PcHome from "../../components/home.vue";
export default {
  name: "Home",
  components: {
    PicNewspaper,
    PcHome,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    // localStorage.setItem("questionnaireItem", 0);
  },
};
</script>

<style lang="stylus" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue